import * as Yup from 'yup'
import { productQuantitySchema } from 'constants/validationSchemas'

export const PRODUCT_HEADER_FIELD_NAMES = {
  QUANTITY: 'quantity',
}

export const getProductHeaderValidationSchema = ({
  minimumOrderQuantity,
  availableQuantity,
  leadTime,
}) =>
  Yup.object().shape({
    [PRODUCT_HEADER_FIELD_NAMES.QUANTITY]: productQuantitySchema({
      fieldName: PRODUCT_HEADER_FIELD_NAMES.QUANTITY,
      minimumOrderQuantity,
      availableQuantity,
      leadTime,
    }),
  })
